// extracted by mini-css-extract-plugin
export default {"mainContainer":"MonthlySavingsAmount_mainContainer__sx3b9","skeletonLoadingAnimation":"MonthlySavingsAmount_skeletonLoadingAnimation__rfQxK"};